exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".content[data-v-4e3cf508]{padding-top:20px;padding-bottom:20px}.container[data-v-4e3cf508]{text-align:left;color:rgba(0,0,0,.8)}main[data-v-4e3cf508]{box-shadow:5px 5px 25px 0 rgba(46,61,73,.2);background-color:#fff;border-radius:.3rem}.btn-outline-primary[data-v-4e3cf508]:hover{color:#fff!important;background-color:#6ad5bf;border-color:#65cb99}.btn-outline-primary[data-v-4e3cf508]{color:#6ad5bf!important;border-color:#6ad5bf}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e3cf508","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MainLayout.vue
// module id = 195
// module chunks = 0